import React from 'react';
import { LinkType } from '../types';

interface PreviewPanelProps {
  link: LinkType;
  onClose: () => void;
}

const PreviewPanel: React.FC<PreviewPanelProps> = ({ link, onClose }) => {
  let embedUrl = link.url;

  try {
    const urlObj = new URL(link.url);
    if (urlObj.hostname.includes('youtube.com') || urlObj.hostname.includes('youtu.be')) {
      let videoId = '';
      if (urlObj.hostname.includes('youtu.be')) {
        videoId = urlObj.pathname.slice(1);
      } else {
        videoId = urlObj.searchParams.get('v') || '';
      }
      if (videoId) {
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
    }
  } catch (e) {
    // invalid URL or similar
  }

  return (
    <div
      className="fixed inset-y-0 left-0 w-96 bg-white border-r border-solid border-black z-50 flex flex-col font-heebo shadow-none rounded-none"
      dir="rtl"
    >
      <div className="flex items-center justify-between p-4 border-b border-solid border-gray-300 bg-gray-50">
        <h3 className="text-sm font-bold truncate text-black">{link.title || 'תצוגה מקדימה של קישור'}</h3>
        <button
          onClick={onClose}
          className="p-1 text-black hover:bg-gray-200 border border-solid border-black text-xs font-bold rounded-none"
        >
          סגור ✕
        </button>
      </div>

      <div className="p-4 border-b border-solid border-gray-200">
        <div className="text-xs font-bold text-gray-500 mb-1">כתובת URL:</div>
        <a
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-blue-600 underline break-all hover:text-blue-800"
        >
          {link.url}
        </a>
      </div>

      <div className="flex-1 bg-gray-100 relative p-2">
        {link.url ? (
          <iframe
            title={link.title || 'Link Preview'}
            src={embedUrl}
            className="w-full h-full border-none bg-white"
            sandbox="allow-scripts allow-same-origin allow-popups"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-500">
            אין כתובת קישור להצגה מקדימה.
          </div>
        )}
      </div>

      <div className="p-4 bg-gray-50 border-t border-solid border-gray-200 text-center text-xs text-gray-400">
        הערה: חלק מהאתרים חוסמים תצוגה בתוך מסגרת (iFrame). במידת הצורך לחצו על הקישור לפתיחה בכרטיסייה חדשה.
      </div>
    </div>
  );
};

export default PreviewPanel;